import { useEffect, useState } from 'react';
import { api, type Leader, type League } from '../lib/api';

/** Statistical leaders with headshots, from ESPN, for live and finished games. */
export function Leaders({ gameId, league }: { gameId: string; league: League }) {
  const [rows, setRows] = useState<Leader[] | null>(null);
  useEffect(() => { api.gameLeaders(gameId, league).then((r) => setRows(r.leaders)).catch(() => setRows([])); }, [gameId, league]);
  if (!rows || !rows.length) return null;
  const wanted = rows.filter((l) => l.player && ['Passing Yards', 'Rushing Yards', 'Receiving Yards'].includes(l.category)).slice(0, 6);
  if (!wanted.length) return null;
  return (
    <div>
      <p className="kicker mb-3">Leaders</p>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
        {wanted.map((l, i) => (
          <div key={i} className="card flex items-center gap-3 p-3">
            {l.headshot ? <img src={l.headshot} alt="" className="h-12 w-12 shrink-0 rounded-full bg-wash object-cover" loading="lazy" /> : <span className="h-12 w-12 shrink-0 rounded-full bg-wash" />}
            <div className="min-w-0">
              <p className="meta truncate !text-[11px]">{l.team}  {l.category.replace(' Yards', '')}</p>
              <p className="truncate text-[14px] font-semibold">{l.player}</p>
              <p className="truncate text-[12px] text-muted">{l.line}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
